import {
    DBxEvent,
    ParserUtil
  } from "cartovista";
  import{drawStyleIconCanvas} from "../../utils/CvUtils";
  import FeatureItem from "./FeatureItem";
  import { Popover } from 'bootstrap';

    export default class ResultItem {
      constructor(resultList, features, name) {
        this._resultList = resultList;
        this._id = resultList.increment;
        this.featuresItems = this._addFeatureItems(features);
        this._collapsed = true;
        this._visible = true;
        this._$resultListRow = null;
        this.name = this._getFeatureName(name);
        this._styleIconCanvas = this._generateStyleIconCanvas();
        Object.defineProperties(this, {
            "collapsed": {
                get: function() { return this._collapsed; },
                set: function(bool) { this._collapsed = bool; }
            },
            "visible": {
                get: function() { return this._visible; },
                set: this._setVisibility.bind(this)
            }
        });
      }

      _setVisibility(bool){
        this._visible = bool;
        _.forEach(this.featuresItems, function(featureItem) {
            featureItem.visible = bool;
        });
      };

      _getFeatureName(name){
        return name ? name : "Requête&nbsp;" + this._id;
      };

    _addFeatureItems(features) {
        return _.map(features, function(feature) {
            return new FeatureItem(this, feature, true);
        }.bind(this));
    };

    removeFeatureItem(featureItem) {
        _.remove(this.featuresItems, featureItem);
        this._resultList.layer.removeFeatures([featureItem.feature]);
        this._resultList.dataTable.removeDataRows([featureItem.feature.id])
        this._resultList.generateUI();
    };

    _generateStyleIconCanvas() {
        var canvas = document.createElement("canvas");
        if(this._resultList.layer.layerType == "POLYGON" || this._resultList.layer.layerType == "POLYLINE"){
            canvas.width = 14;
            canvas.height = 14;
        }
        drawStyleIconCanvas(canvas, this.featuresItems[0].feature.style);
        return canvas;
    };

    _generateResultItemUI(containerId) {
        this._$resultListRow = $((this._resultList._accordion ? '<div class="accordion-item">' +
                                    '<div class="accordion-header" id="' + containerId + '_ResultList_accordionHeading_' + this._id + '">' : '<li class="list-group-item">') + 
                                      '<div class="row">' +
                                        '<div class="col col-1 text-center">' +
                                            '<a class="ResultsList_zoom_link" href="javascript:void(0);" title="Zoomer"><i class="bi bi-zoom-in"></i></a>' +
                                        '</div>' +
                                        '<div class="col col-1 text-center">' +
                                            '<input class="ResultsList_toggleVisible_input" type="checkbox" ' + (this.visible ? 'checked="checked"' : '') + ' title="Changer la visibilité">' +
                                        '</div>' +
                                        '<div class="col col-1 text-center" style="height:14px;">' +
                                            '<a class="ResultsList_changeColor_popover" href="javascript:void(0);" data-bs-toggle="popover"><span class="ResultsList_symbolCanvas" title="Changer la couleur"></span></a>' +
                                        '</div>' +
                                        '<div class="col col-7">' +
                                            (this._resultList._accordion ? '<a class="ResultList_toggleCollapse_link" role="button" data-bs-toggle="collapse" data-bs-target="#' + containerId + '_ResultList_accordionPanel_' + this._id + '" aria-expanded="' + this.collapsed + '" aria-controls="' + containerId + '_ResultList_accordionPanel_' + this._id + '" title="Ouvrir/réduire le panneau">' + this.name + '</a>' : 
                                            this.name ) +
                                        '</div>' +
                                        '<div class="col col-1 text-center">' +
                                            '<a class="ResultsList_dataView_link" href="javascript:void(0);" title="Voir les données"><i class="bi bi-table"></i></a>' +
                                        '</div>' +
                                        '<div class="col col-1 text-center">' +
                                            '<a class="ResultsList_delete_link" href="javascript:void(0);" title="Supprimer"><i class="bi bi-trash3"></i></a>' +
                                        '</div>' +
                                      '</div>' +
                                      (this._resultList._accordion ? '</div>' +
                                      '<div id="' + containerId + '_ResultList_accordionPanel_' + this._id + '" class="accordion-collapse collapse ' + (this.collapsed ? "" : "show") + '" aria-labelledby="' + containerId + '_ResultList_accordionHeading_' + this._id + '">' +
                                        '<ul class="list-group"></ul>' +
                                      '</div>' +
                                    '</div>' : '</li'));

        this._$resultListRow.find(".ResultsList_symbolCanvas").html(this._styleIconCanvas);

        this._$resultListRow.mouseenter(function() {
            this._resultList.layer.rolloverFeatures = _.map(this.featuresItems, "feature");
        }.bind(this));
        this._$resultListRow.mouseleave(function() {
            this._resultList.layer.rolloverFeatures = [];
        }.bind(this));
        this._$resultListRow.find(".ResultsList_zoom_link").click(function() {
            this._resultList.zoomOnFeatures(_.map(this.featuresItems, "feature"));
        }.bind(this));
        this._$resultListRow.find(".ResultsList_toggleVisible_input").click(function() {
            this.visible = !this.visible;
        }.bind(this));
        _.forEach(this._$resultListRow.find(".ResultsList_changeColor_popover"), function(popover){
            new Popover(popover, {
              "template": '<div class="ResultsList_colorPicker_popover popover" role="popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>',
              "content": '<div class="ResultsList_colorPicker"></div>',
              "container": "body",
              "placement": "auto",
              "html": true,
              "trigger":"manual"
            });
          });
          this._$resultListRow.find(".ResultsList_changeColor_popover").click(function(evt) {
              Popover.getInstance(evt.currentTarget).toggle();
              $("body").on("mouseup.popover", function(e) {
                  if (!$(e.target).parents(".ResultsList_colorPicker_popover").length) {
                      Popover.getInstance(evt.currentTarget).hide();
                      $("body").off("mouseup.popover");
                  }
              });
          });
  
          _.forEach(this._$resultListRow.find(".ResultsList_changeColor_popover"), function(popover){
            popover.addEventListener("shown.bs.popover", function() {
                $(".ResultsList_colorPicker").kendoFlatColorPicker({
                    "value": this._resultList.layer.layerType == "POLYGON" ? this.featuresItems[0].feature.style.symbolizers[0].fillColor.rgba : this._resultList.layer.layerType == "POLYLINE" ? this.featuresItems[0].feature.style.symbolizers[0].strokeColor.rgba : this.featuresItems[0].feature.style.symbolizers[0].color.rgba,
                    "autoupdate": true,
                    "change": _.debounce(this._onColorPickerChanged.bind(this), 100)
                });
            }.bind(this));
          }.bind(this));
        this._$resultListRow.find(".ResultList_toggleCollapse_link").click(function() {
            this.collapsed = !this.collapsed;
        }.bind(this));
        this._$resultListRow.find(".ResultsList_dataView_link").click(function() {
            this._resultList.toggleFeatureDataView(_.map(this.featuresItems, "feature"));
        }.bind(this));
        this._$resultListRow.find(".ResultsList_delete_link").click(function() {
            this._resultList.removeResult(this);
        }.bind(this));

        this._$resultListRow.find(".list-group").html(_.reverse(_.invokeMap(this.featuresItems, "_generateFeatureItemRow")));

        return this._$resultListRow;
    }

    _onColorPickerChanged(obj) {
        if(this._resultList.layer.layerType == "POLYGON") this.featuresItems[0].feature.style.symbolizers[0].fillColor1 = ParserUtil.parseColor(obj.value);
        else if(this._resultList.layer.layerType == "POLYLINE") this.featuresItems[0].feature.style.symbolizers[0].strokeColor = ParserUtil.parseColor(obj.value);
        else if(this._resultList.layer.layerType == "POINT") this.featuresItems[0].feature.style.symbolizers[0].color = ParserUtil.parseColor(obj.value);
        this.featuresItems[0].feature.style.styleLabelProperties.color = ParserUtil.parseColor(obj.value);
        this.featuresItems[0].feature.dispatchEvent(new DBxEvent(this.featuresItems[0].feature.EVENTS.CONTENT_CHANGED));
        this._styleIconCanvas = this._generateStyleIconCanvas();
        this._$resultListRow.find(".ResultsList_symbolCanvas").html(this._styleIconCanvas);
    };
}
